import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxArchive } from "@fortawesome/pro-regular-svg-icons/faBoxArchive";

import { useIsEditor } from "../DocumentView/DocumentContext";

interface Props {
  archived?: boolean;
}

const ArchivedElementBanner: React.FC<Props> = ({ archived }) => {
  const isEditor = useIsEditor();

  if (!isEditor || !archived) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 text-xs text-red-600 dark:text-red-400 mt-2">
      <FontAwesomeIcon icon={faBoxArchive} className="h-3 w-3" />
      <span>
        This element has been archived and will not appear in the form
      </span>
    </div>
  );
};

export default ArchivedElementBanner;
